import React, { useCallback } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useModalContext } from '@bcraft-frontend-lib/core'
import block from 'bem-cn'

import logoutConfirmImg from 'shared/img/logout-confirm.png'

import { logout } from 'features/auth/actions'
import { selectLocaleDict } from 'features/locale/selectors'

import { Button, ButtonSizes, Icon } from 'components/UIKit'

import './LogoutConfirmModal.scss'

type LogoutConfirmModalProps = {
  path: string
}

const b = block('logout-confirm-modal')

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({ path }) => {
  const dispatch = useDispatch()
  const { closeModal } = useModalContext()
  const locale = useSelector(selectLocaleDict, shallowEqual).common
  const l = locale.logoutConfirm

  const onClose = useCallback(() => {
    closeModal(path)()
  }, [closeModal, path])

  const onLogout = useCallback(() => {
    dispatch(logout())
    onClose()
  }, [dispatch, onClose])

  return (
    <div className={b()}>
      <div className={b('header')}>
        <span className={b('header-title')}>{l.title}</span>
        <button type="button" className={b('header-close')} onClick={onClose} aria-label="Close">
          <Icon type="close" />
        </button>
      </div>
      <div className={b('body')}>
        <div className={b('image-wrap')}>
          <img src={logoutConfirmImg} alt="" className={b('image')} />
        </div>
        <div className={b('content')}>
          <h2 className={b('heading')}>{l.heading}</h2>
          <p className={b('description')}>{l.description}</p>
          <Button
            className={b('button')}
            text={l.button}
            onClick={onLogout}
            uppercase
            fullWidth
            size={ButtonSizes.LARGE}
          />
        </div>
      </div>
    </div>
  )
}
